import React from "react";
import Contact from "../Contact/Contact";
import MySkills from "../MySkills/MySkills";
import Projects from "../Project/Projects";
import Banner from "./Banner/Banner";
import Experience from "../Experience/Experience";

const Home = () => {
  return (
    <div>
      <Banner></Banner>
      <Projects ></Projects>
      <Experience/>
      <MySkills></MySkills>
      <Contact></Contact>
    </div>
  );
};

export default Home;
